import { Component } from 'react';

import ExternalImage, { ExternalImageProps } from '../ExternalImage/ExternalImage';
import css from './BackgroundImage.css';

interface BackgroundImageProps extends ExternalImageProps {}

export default class BackgroundImage extends Component<BackgroundImageProps, {}> {
  render() {
    const { src, name } = this.props;
    return <ExternalImage className={css.BackgroundImage} src={src} alt={name} />;
  }
}
